import { AppLanguage, getPreferredLanguage } from '../language';

export interface AddressBookI18nTemplate {
  ui: {
    actionMyAddresses: string;
    actionLoginNow: string;
    dropdownEdit: string;
    dropdownCopy: string;
    dropdownDelete: string;
    addressLandingDescription: string;
    addressTagDefault: string;
    addressFilterAllTypes: string;
    addressFilterTypeDefault: string;
    addressFilterTypeNormal: string;
    addressFilterAllStates: string;
    addressSearchPlaceholder: string;
    addressActionAdd: string;
    addressActionShipNow: string;
    addressDrawerTitleEdit: string;
    addressDrawerTitleAdd: string;
    addressDrawerActionDone: string;
    addressDrawerRecipientNamePlaceholder: string;
    addressDrawerAliasPlaceholder: string;
    addressDrawerSectionAddress: string;
    addressDrawerStreetPlaceholder: string;
    addressDrawerRoomPlaceholder: string;
    addressDrawerCityPlaceholder: string;
    addressDrawerStatePlaceholder: string;
    addressDrawerZipPlaceholder: string;
    addressDrawerSectionOther: string;
    addressDrawerPhonePlaceholder: string;
    addressDrawerSetDefaultShipping: string;
    addressDrawerSaveFailed: string;
  };
}

export const TEMPLATES: Record<AppLanguage, AddressBookI18nTemplate> = {
  zh: {
    ui: {
      actionMyAddresses: '我的地址',
      actionLoginNow: '立即登录',
      dropdownEdit: '编辑',
      dropdownCopy: '复制',
      dropdownDelete: '删除',
      addressLandingDescription: '管理您的所有常用发货地址。一站式管理，下单更轻松高效。',
      addressTagDefault: '默认',
      addressFilterAllTypes: '所有类型',
      addressFilterTypeDefault: '默认地址',
      addressFilterTypeNormal: '普通地址',
      addressFilterAllStates: '所有州',
      addressSearchPlaceholder: '搜索姓名、备注名、街道、城市或邮编',
      addressActionAdd: '添加地址',
      addressActionShipNow: '立即发货',
      addressDrawerTitleEdit: '编辑地址',
      addressDrawerTitleAdd: '添加地址',
      addressDrawerActionDone: '完成',
      addressDrawerRecipientNamePlaceholder: '收件人姓名',
      addressDrawerAliasPlaceholder: '备注名 · 选填',
      addressDrawerSectionAddress: '地址',
      addressDrawerStreetPlaceholder: '街道',
      addressDrawerRoomPlaceholder: '房间号 · 选填',
      addressDrawerCityPlaceholder: '城市',
      addressDrawerStatePlaceholder: '州',
      addressDrawerZipPlaceholder: '邮编',
      addressDrawerSectionOther: '其他',
      addressDrawerPhonePlaceholder: '联系电话',
      addressDrawerSetDefaultShipping: '设为默认发货地址',
      addressDrawerSaveFailed: '保存失败',
    },
  },
  en: {
    ui: {
      actionMyAddresses: 'My addresses',
      actionLoginNow: 'Log in now',
      dropdownEdit: 'Edit',
      dropdownCopy: 'Copy',
      dropdownDelete: 'Delete',
      addressLandingDescription: 'Manage your frequent shipping addresses in one place and place orders faster.',
      addressTagDefault: 'Default',
      addressFilterAllTypes: 'All types',
      addressFilterTypeDefault: 'Default address',
      addressFilterTypeNormal: 'Regular address',
      addressFilterAllStates: 'All states',
      addressSearchPlaceholder: 'Search name, alias, street, city, or ZIP code',
      addressActionAdd: 'Add address',
      addressActionShipNow: 'Ship now',
      addressDrawerTitleEdit: 'Edit address',
      addressDrawerTitleAdd: 'Add address',
      addressDrawerActionDone: 'Done',
      addressDrawerRecipientNamePlaceholder: 'Recipient name',
      addressDrawerAliasPlaceholder: 'Alias · Optional',
      addressDrawerSectionAddress: 'Address',
      addressDrawerStreetPlaceholder: 'Street',
      addressDrawerRoomPlaceholder: 'Apt/Suite · Optional',
      addressDrawerCityPlaceholder: 'City',
      addressDrawerStatePlaceholder: 'State',
      addressDrawerZipPlaceholder: 'ZIP code',
      addressDrawerSectionOther: 'Other',
      addressDrawerPhonePlaceholder: 'Phone number',
      addressDrawerSetDefaultShipping: 'Set as default shipping address',
      addressDrawerSaveFailed: 'Save failed',
    },
  },
};

export const ADDRESS_BOOK_NAMESPACE = 'addressBook';

export const ADDRESS_BOOK_RESOURCE_KEY = 'template';

export const ADDRESS_BOOK_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof ADDRESS_BOOK_RESOURCE_KEY, AddressBookI18nTemplate>
> = {
  zh: {
    [ADDRESS_BOOK_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [ADDRESS_BOOK_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getAddressBookTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): AddressBookI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
